import {useState} from 'react';
import {
    Box,
    Typography,
    Button,
    Card,
    TextField,
} from '@mui/material';
import { VerticalSpace } from '../components';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import axios from 'axios';
import moment from 'moment';
import {toast} from 'react-toastify';

const CreateKid = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');

    const onSubmit = async () => {
        try {
            setIsLoading(true);
            const {data} = await axios.post("https://dapp-backend.triadkube.com/auth/create-kid", {name, parent: searchParams.get('id'), createdOn: moment.utc()})
            setIsLoading(false);
            navigate(`/dashboard?testDoc=${searchParams.get('testDoc')}`)
        } catch (error) {
            setIsLoading(false);
            toast.error("Something Went Wrong");
        }
    }

    return (
        <Box>
            <Card
                sx={{
                    padding: '50px'
                }}
            >
                <Typography>Let's create a profile for your kid (choose an anonymous name)</Typography>
                <VerticalSpace count={2} />
                <TextField variant='outlined' label="Username" onChange={(evt) => setName(evt.target.value)} />
                <VerticalSpace count={2} />
                <Box>
                    <LoadingButton loading={isLoading} loadingIndicator="Loading..." variant='contained' onClick={onSubmit} >Submit</LoadingButton>
                </Box>
            </Card>
        </Box>
    )
}

export default CreateKid;